/**
 * --------------------------------------------------------------------------------------
 * PRODUCT - ALTERNATE. BLOCK: CIRCLE PROGRESS BAR
 * --------------------------------------------------------------------------------------
 */

document.addEventListener('DOMContentLoaded', () => {

  function circleProgressBarInit() {
    let circles = document.getElementsByClassName('mrx_circle-progress-bar-circle-elem');

    if (circles) {
      let circles_bar = [];

      for (let i = 0; i < circles.length; i++) {
        let percentage = circles[i].dataset['value'],
            color = circles[i].dataset['color'],
            trailColor = circles[i].dataset['trail'];

        circles_bar[i] = new ProgressBar.Circle(circles[i], {
          color: color,
          trailColor: trailColor,
          strokeWidth: 3,
          trailWidth: 3,
          duration: 5000,
          step: function (state, circle) {
            circle.path.setAttribute('stroke', state.color);

            let value = Math.round(circle.value() * 100);
            if (value === 0) {
              circle.setText('');
            } else {
              circle.setText(value);
            }
          }
        });

        circles_bar[i].animate(percentage, {
          from: {
              color: color
          },
          to: {
              color: color
          }
        });
      }
    }
  }

  circleProgressBarInit();

  document.addEventListener('shopify:block:select', (e) => {
    let block = e.target;

    if ( e.detail.load && block.classList.contains('mrx_circle-progress-bar') ) {
      circleProgressBarInit();
    }
  });
});